import { render, staticRenderFns } from "./IncRewardName.vue?vue&type=template&id=722c3699"
import script from "./IncRewardName.vue?vue&type=script&lang=js"
export * from "./IncRewardName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports